/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface OnHoldDisposition
 */
export interface OnHoldDisposition {
    /**
     * 
     */
    status: OnHoldDispositionStatusEnum;
    /**
     * An onhold code from episode_of_care_status_reasons
     */
    status_reason: string;
    /**
     * Defaults to true
     */
    bed_hold?: boolean;
    /**
     * On or after actual_end_at. Needs a bed hold.
     */
    bed_hold_end_at?: Date;
}


/**
 * @export
 */
export const OnHoldDispositionStatusEnum = {
    Onhold: 'onhold',
} as const;
export type OnHoldDispositionStatusEnum = typeof OnHoldDispositionStatusEnum[keyof typeof OnHoldDispositionStatusEnum];


/**
 * Check if a given object implements the OnHoldDisposition interface.
 */
export function instanceOfOnHoldDisposition(value: object): value is OnHoldDisposition {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (value['status'] !== 'onhold') return false;
    
    if (!('status_reason' in value) || value['status_reason'] === undefined) return false;
    return true;
}

export function OnHoldDispositionFromJSON(json: any): OnHoldDisposition {
    return OnHoldDispositionFromJSONTyped(json, false);
}

export function OnHoldDispositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnHoldDisposition {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'status_reason': json['status_reason'],
        'bed_hold': json['bed_hold'] == null ? undefined : json['bed_hold'],
        'bed_hold_end_at': json['bed_hold_end_at'] == null ? undefined : (parseDateTime(json['bed_hold_end_at'])),
    };
}

export function OnHoldDispositionToJSON(json: any): OnHoldDisposition {
    return OnHoldDispositionToJSONTyped(json, false);
}

export function OnHoldDispositionToJSONTyped(value?: OnHoldDisposition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'status_reason': value['status_reason'],
        'bed_hold': value['bed_hold'],
        'bed_hold_end_at': value['bed_hold_end_at'] == null ? value['bed_hold_end_at'] : serializeDateTime(value['bed_hold_end_at']),
    };
}

